// Code generated by balancegen from data/contracts/languages.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// The language pick and the load of a second language (i18n.md §1.1, §2,
// R855, R1429). The pick runs once, when this module evaluates. Each page
// has a boot module that awaits loadLanguage() and then imports the
// application, so gen/strings.ts finds the tables already loaded.
//
// This module must stay small and must not import gen/strings.ts at run
// time: the boot chunk of every page carries it. It holds no top-level
// await, because in Rolldown's lazy module init an await makes every
// importer's init async (R1429).

import { pickLanguage } from '../locale/pick';
import type { StringTables } from './strings';

/** The languages the game speaks (data/contracts/languages.toml). The
 *  first tag is the source language. */
export const LOCALES = ['en', 'de'] as const;
export type Locale = (typeof LOCALES)[number];

/** The language this page runs in (i18n.md §2, R855). It is picked once,
 *  when this module evaluates: the stored LANGUAGE setting, else the
 *  source language. The pick never reads the browser's list (R2207). */
export const LOCALE: Locale = pickLanguage(LOCALES) as Locale;

/** The language parts of each second language (R3108). One static path
 *  per part, so the bundler writes one lazy chunk per part. The parts of
 *  the source language are not here: gen/strings.ts imports them
 *  statically (R3123). */
const LANGUAGE_PARTS: Partial<Record<Locale, () => Promise<readonly { readonly tables: Partial<StringTables> }[]>>> = {
  de: () =>
    Promise.all([
      import('./strings.de.1'),
      import('./strings.de.2'),
      import('./strings.de.3'),
    ]),
};

let loaded: StringTables | undefined;

/** Loads every language part of a language and joins their tables, or
 *  answers undefined for the source language. Each section is in
 *  exactly one part, so the join loses no table. */
export async function readLanguageTables(tag: Locale): Promise<StringTables | undefined> {
  const load = LANGUAGE_PARTS[tag];
  if (load === undefined) return undefined;
  const parts = await load();
  return Object.assign({}, ...parts.map((p) => p.tables)) as StringTables;
}

/** Loads the tables of LOCALE when it is a second language. The page's
 *  boot module awaits it before it imports the application. A second call
 *  loads nothing more. */
export async function loadLanguage(): Promise<void> {
  if (loaded !== undefined) return;
  loaded = await readLanguageTables(LOCALE);
}

/** The loaded tables of a second language, else undefined. */
export function languageTables(): StringTables | undefined {
  return loaded;
}
